import React from 'react'
import Styles from './DistributionMetrics.module.scss'
import { MetricContainer } from '../MetricContainer/MetricContainer'
import { Spin } from 'common/Spin/Spin'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'

export interface Distribution {
  label: string
  percentage: number
}

interface DistributionRowProps {
  label: string
  percentage: number
}

const DistributionRow: React.FC<DistributionRowProps> = ({ label, percentage }) => {
  return (
    <div className={Styles.distributionRow}>
      <div className={Styles.label}>{label}</div>
      <div className={Styles.barContainer}>
        <div className={Styles.bar}>
          <div className={Styles.fill} style={{ width: `${percentage}%` }} />
        </div>
      </div>
      <div className={Styles.percentage}>{percentage.toFixed(1)}%</div>
    </div>
  )
}

interface DistributionMetricProps {
  title: string
  tooltip: string
  data: Distribution[]
  maxItems?: number
  isFetching?: boolean
  errorTitle?: string
  errorMessage?: string
}

export const DistributionMetric: React.FC<DistributionMetricProps> = ({
  title,
  tooltip,
  data,
  maxItems = 5,
  isFetching,
  errorTitle,
  errorMessage,
}) => {
  const sortedData = [...data].sort((a, b) => b.percentage - a.percentage).slice(0, maxItems)

  if (isFetching) {
    return (
      <MetricContainer name={title} tooltip={tooltip}>
        <div className={Styles.loadingContainer}>
          <Spin />
        </div>
      </MetricContainer>
    )
  }

  if (errorTitle && errorMessage) {
    return (
      <MetricContainer name={title} tooltip={tooltip}>
        <div className={Styles.errorContainer}>
          <Heading level={5}>{errorTitle}</Heading>
          <Text>{errorMessage}</Text>
        </div>
      </MetricContainer>
    )
  }

  if (sortedData.length === 0) {
    return (
      <MetricContainer name={title} tooltip={tooltip}>
        <div className={Styles.loadingContainer}>This data isn't ready yet, check back soon!</div>
      </MetricContainer>
    )
  }

  return (
    <MetricContainer name={title} tooltip={tooltip}>
      {sortedData.map((item, index) => (
        <DistributionRow key={index} label={item.label} percentage={item.percentage} />
      ))}
    </MetricContainer>
  )
}
